import { render, staticRenderFns } from "./LandlordInvoice.vue?vue&type=template&id=a2f37058&scoped=true"
import script from "./LandlordInvoice.vue?vue&type=script&lang=js"
export * from "./LandlordInvoice.vue?vue&type=script&lang=js"
import style0 from "./LandlordInvoice.vue?vue&type=style&index=0&id=a2f37058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f37058",
  null
  
)

export default component.exports